import { render, staticRenderFns } from "./share-cfds.vue?vue&type=template&id=476d6f96&scoped=true"
import script from "./share-cfds.vue?vue&type=script&lang=js"
export * from "./share-cfds.vue?vue&type=script&lang=js"
import style0 from "./share-cfds.vue?vue&type=style&index=0&id=476d6f96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d6f96",
  null
  
)

export default component.exports